const KEY = 'nb.sound.off.';
let ctx = null;
let sid = 'guest';
let muted = false;
const subs = new Set();
const emit = () => subs.forEach((fn) => fn());

export const isMuted = () => muted;

export const subscribeSound = (fn) => {
  subs.add(fn);

  return () => subs.delete(fn);
};

const readMuted = () => {
  try {
    return localStorage.getItem(KEY + sid) === '1';
  } catch (e) {
    return false;
  }
};

const storeMuted = () => {
  try {
    localStorage.setItem(KEY + sid, muted ? '1' : '0');

    return true;
  } catch (e) {
    return false;
  }
};

const stopSpeech = () => {
  try {
    window.speechSynthesis.cancel();

    return true;
  } catch (e) {
    return false;
  }
};

export const initSound = (studentId) => {
  sid = String(studentId || 'guest');
  muted = readMuted();
  emit();
};

const getCtx = () => {
  if (!ctx) {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return null;
    ctx = new AudioCtx();
  }
  if (ctx.state === 'suspended') ctx.resume();

  return ctx;
};

export const unlockAudio = () => {
  if (muted) return;
  try {
    getCtx();
  } catch (e) {
    ctx = null;
  }
};

export const setMuted = (value) => {
  muted = Boolean(value);
  storeMuted();
  if (muted) {
    stopSpeech();
    if (ctx && ctx.state === 'running') ctx.suspend();
  }
  emit();
};

const tone = (frequency, start, duration, type = 'sine', volume = 0.16) => {
  const audio = getCtx();
  if (!audio) return;
  const osc = audio.createOscillator();
  const gain = audio.createGain();
  osc.type = type;
  osc.frequency.value = frequency;
  const at = audio.currentTime + start;
  gain.gain.setValueAtTime(0.0001, at);
  gain.gain.exponentialRampToValueAtTime(volume, at + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, at + duration);
  osc.connect(gain).connect(audio.destination);
  osc.start(at);
  osc.stop(at + duration + 0.05);
};

const SFX = {
  tap: () => tone(700, 0, 0.05, 'triangle', 0.07),
  ok: () => {
    tone(784, 0, 0.12, 'triangle', 0.14);
    tone(1175, 0.09, 0.2, 'triangle', 0.14);
  },
  bad: () => {
    tone(260, 0, 0.16, 'sawtooth', 0.06);
    tone(196, 0.12, 0.22, 'sawtooth', 0.06);
  },
  combo: () => [659, 784, 988, 1319].forEach((f, i) => tone(f, i * 0.06, 0.14, 'square', 0.05)),
  up: () => [523, 659, 784, 1047].forEach((f, i) => tone(f, i * 0.08, 0.18, 'triangle', 0.12)),
  win: () => [523, 659, 784, 1047, 784, 1047, 1319].forEach((f, i) => tone(f, i * 0.1, 0.28, 'triangle', 0.13)),
  flip: () => tone(520, 0, 0.06, 'sine', 0.08),
  tick: () => tone(1250, 0, 0.03, 'square', 0.05),
};

export const playSfx = (name) => {
  if (muted || !SFX[name]) return;
  try {
    SFX[name]();
  } catch (e) {
    ctx = null;
  }
};
